export interface Navigation {
  width: number;
}

const navigation: Navigation = {
  width: 380,
};

export default navigation;
